import { customQuery } from 'config/reactQuery/reactQuery';
import { useMutation } from 'react-query';

export interface StripePaymentValues {
  endpoint: string;
  data: {
    stripe_credit_card_brand: string;
    stripe_credit_card_country: string | null;
    stripe_credit_card_exp_month: number;
    stripe_credit_card_exp_year: number;
    stripe_credit_card_last4: string;
    stripe_credit_card_token: string;
    stripe_credit_card: string;
    cardholder_name: string | null;
  };
  additionalSendData?: any;
}

export const useStripePaymentMutation = () => {
  return useMutation((values: StripePaymentValues) => {
    const additionalData = values.additionalSendData ?? {};

    return customQuery(values.endpoint, {
      values: { ...values.data, ...additionalData },
      method: 'POST',
      shouldAcceptFalseSuccess: true,
    });
  });
};
